import { type FC, memo } from 'react';
import {
  PauseCircleOutline,
  PlayCircleOutline,
} from '@eqi-investimentos/icons/web';
import { PlayerButton } from './Button';

const PlayPauseButton: FC<PlayPauseButtonProps> = ({ isPlaying, onToggle }) => (
  <PlayerButton label={isPlaying ? 'Pause' : 'Play'} onClick={onToggle}>
    {isPlaying ? (
      <PauseCircleOutline boxSize="4.5rem !important" />
    ) : (
      <PlayCircleOutline boxSize="4.5rem !important" />
    )}
  </PlayerButton>
);

export default memo(PlayPauseButton);

type PlayPauseButtonProps = {
  isPlaying: boolean;
  onToggle: () => void;
};
